import { TOKEN } from 'constants/tokens'

export interface IBscEvent {
  address: string
  data: string
  blockNumber: string
  transactionHash: string
  logIndex: string
  timeStamp: string
  topics: string[]
  transactionIndex: string
  args: any
  name: string
  signature: string
  topic: string
}

export interface IBurn {
  date: number
  status: string
  token: string
  burnAmount: string
  priceBlock: number
  action: string
  eventIndex: number
  txid: string
  block: number
}

export class Burn implements IBurn {
  date: number

  status: string

  token: string

  burnAmount: string

  priceBlock: number

  action: string

  eventIndex: number

  txid: string

  block: number

  constructor(event: IBscEvent) {
    this.date = Number(event.timeStamp) * 1000
    this.status = 'SUCCESS'
    this.token = TOKEN.CNR
    this.burnAmount = String(event.args.riseAmountBurnt) ?? '0'
    this.priceBlock = Number(event.args.currentHour) ?? 0
    this.action = event.name
    this.eventIndex = Number(event.logIndex)
    this.txid = event.transactionHash
    this.block = Number(event.blockNumber)
  }
}
